import { CmpsPopulationCompareGroupData } from '@cmps/ng-kit';

import { PerformancePopulationCompare } from '.././models/population-compare.model';
import { CriteriaIdTypeNames } from '../models/criteria-type.model';
import { PerformanceCard } from '../models/performance-card.model';

export function getPopulationCompareData(
    card: PerformanceCard,
    data: PerformancePopulationCompare,
): CmpsPopulationCompareGroupData[] {
    if (data == null) {
        return [];
    }

    let populationData = data.items;
    const populationDialogData: CmpsPopulationCompareGroupData[] = [];
    const tempData = {};
    populationData = data.items.filter(
        (f) =>
            new Date(f.eventDate).getTime() ===
            new Date(card.endDate).getTime(),
    );
    populationData.forEach((e) => {
        tempData[e.type] = Array.from(
            new Set(populationData.filter((ee) => ee.type === e.type)),
        );
    });

    Object.keys(tempData)?.forEach((e) => {
        populationDialogData.push({
            groupValue: CriteriaIdTypeNames[e],
            id: Number(e),
            subgroup: tempData[e]?.map((sub) => {
                return {
                    subgroupValue: sub.name,
                    id: Number(sub.id),
                    isSelected: false,
                };
            }),
        });
    });

    return populationDialogData;
}
